import { createSlice } from '@reduxjs/toolkit';
import { setIsLoading } from '../Loader/LoaderSlice';
import { setApiError } from '../Error/ErrorSlice';
import { fireApi } from '../../../utils/FireApi';
import { AgreementApi, DataSourceApi } from '../../../utils/Apis';
import { resetStore } from '../../Actions';

const initialState = {
  list_data: null,
  view_data: null,
  edit_data: null,
  validate_data: null,
  agent_list: null
};

const DataSourceSlice = createSlice({
  name: 'DataSource',
  initialState,
  reducers: {
    setDataSourceGrid(state, action) {
      state.list_data = action.payload;
    },
    setDataSourceView(state, action) {
      state.view_data = action.payload;
    },
    setDataSourceEdit(state, action) {
      state.edit_data = action.payload;
    },
    setDataSourceValidate(state, action) {
      state.validate_data = action.payload;
    },
    setAgentGrid(state, action) {
      state.agent_list = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(resetStore, () => initialState); // clear store
  }
});

// DataSource List
export const getDataSourceList = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: DataSourceApi?.dataSourceList,
      method: 'post',
      payload: data
    });
    // console.log('data source res', res);
    // 🔹 Handle success
    if (res?.success) {
      dispatch(setDataSourceGrid(res?.data?.content ? res?.data?.content : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setDataSourceGrid(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ DataSource List failed ', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 DataSource List exception ', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// DataSource View
export const getDataSourceView =
  ({ rowId }) =>
  async (dispatch) => {
    dispatch(setIsLoading({ loading: true }));
    try {
      const res = await fireApi({
        endpoint: `/data-source/${rowId}/view`,
        method: 'get'
      });
      // console.log('data source view res', res);
      // 🔹 Handle success
      if (res?.success) {
        dispatch(setDataSourceView(res?.data ? res?.data : res?.data)); // store in redux
        return res?.data;
      } else {
        dispatch(setDataSourceView(null)); // store in redux
        dispatch(setApiError(res?.message || 'Something went wrong'));
        console.error('❌ DataSource View failed ', res?.data?.error);
        return null;
      }
    } catch (error) {
      dispatch(setApiError('Something went wrong'));
      console.error('🔥 DataSource View exception ', error);
      return null;
    } finally {
      dispatch(setIsLoading({ loading: false }));
    }
  };

// DataSource View
export const getDataSourceValidate =
  ({ rowId }) =>
  async (dispatch) => {
    dispatch(setIsLoading({ loading: true }));
    try {
      const res = await fireApi({
        endpoint: `${DataSourceApi?.dataSourceValidate}/${rowId}`,
        method: 'get'
      });
      // console.log('data source validate res', res);
      // 🔹 Handle success

      if (res?.success) {
        dispatch(setDataSourceValidate(res?.data ? res?.data : res?.data)); // store in redux
        return res?.data;
      } else {
        dispatch(setDataSourceValidate(null)); // store in redux
        dispatch(setApiError(res?.message || 'Something went wrong'));
        console.error('❌ DataSource validate failed ', res?.data?.error);
        return null;
      }
    } catch (error) {
      dispatch(setApiError('Something went wrong'));
      console.error('🔥 DataSource validate exception ', error);
      return null;
    } finally {
      setTimeout(() => {
        dispatch(setIsLoading({ loading: false }));
      }, [1000]);
    }
  };

// DataSource agent list
export const getAgentList = (data) => async (dispatch) => {
  dispatch(setAgentGrid(null));
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: DataSourceApi?.agentList,
      method: 'post',
      payload: data
    });
    // console.log('agent in slice', res);
    // 🔹 Handle success
    if (res?.success) {
      dispatch(setAgentGrid(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setAgentGrid(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ DataSource List failed ', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 DataSource List exception ', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// Agreement Edit
export const getAgreemetEditData = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: AgreementApi?.agreementEdit,
      method: 'post',
      payload: data
    });

    // 🔹 Handle success
    if (res?.success) {
      dispatch(setAgreementEdit(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setAgreementEdit(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Agreement Edit failed ', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Agreement Edit exception ', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

export const {
  setAgreementGrid,
  setDataSourceView,
  setDataSourceGrid,
  setAgreementView,
  setAgreementEdit,
  setDataSourceValidate,
  setAgentGrid
} = DataSourceSlice.actions;
export default DataSourceSlice.reducer;
